export default __webpack_public_path__ + "static/media/messenger.22ef5ae8.png";